import { render, staticRenderFns } from "./FormRO06.vue?vue&type=template&id=332f7f99"
import script from "./FormRO06.vue?vue&type=script&lang=js"
export * from "./FormRO06.vue?vue&type=script&lang=js"
import style0 from "./FormRO06.vue?vue&type=style&index=0&id=332f7f99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports